import React, { useEffect,useRef,useState } from 'react';
import { NavLink,useLocation,useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useApp } from '../contexts/AppContext';


import Header from './Header';



import QuickAddForm from './QuickAddForm';
import SafeIcon from '../common/SafeIcon';
import * as Fi from 'react-icons/fi';
import * as FiIcons from 'react-icons/fi';
import {dbService} from '../services/dbService';
import {settingsService} from '../services/settingsService';



// Consolidated from src/components/Sidebar.jsx; keep its behavior intact.
const Sidebar = (()=>{




const nav=[['Dashboard','/',Fi.FiHome],['Transactions','/transactions',Fi.FiList],['Recurring','/recurring',Fi.FiRepeat],['Budgets','/budgets',Fi.FiTarget],['Categories','/categories',Fi.FiGrid],['People','/people',Fi.FiUsers],['Reports','/reports',Fi.FiBarChart2],['Settings','/settings',Fi.FiSettings]];
function Sidebar(){const {state}=useApp();return <aside className={'fixed xl:static inset-y-0 left-0 z-50 w-60 bg-white border-r border-slate-200 flex flex-col transition-transform xl:translate-x-0 '+(state.ui.sidebarOpen?'translate-x-0':'-translate-x-full')}>
<div className="flex items-center gap-3 px-5 h-20 border-b border-slate-100"><div className="w-10 h-10 rounded-xl bg-blue-600 text-white grid place-items-center shadow-sm"><Fi.FiDollarSign size={23}/></div><div><div className="font-bold text-slate-900 text-sm leading-5">Expense Manager <span className="text-blue-600">Pro</span></div><p className="text-xs text-slate-400">Version 2.0</p></div></div>
<nav className="p-3 pt-6 space-y-1 flex-1">{nav.map(([name,to,Icon])=><NavLink to={to} key={name} className={({isActive})=>'flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-semibold transition-colors '+(isActive?'bg-blue-50 text-blue-600':'text-slate-500 hover:text-blue-600 hover:bg-slate-50')}><Icon size={19}/>{name}</NavLink>)}</nav>
<div className="p-4 border-t border-slate-100"><div className="flex items-center gap-3 text-sm text-slate-600"><Fi.FiGlobe size={18}/><div><p className="text-xs text-slate-400">Currency</p><strong>{state.settings.currency||'AUD'}</strong></div></div></div></aside>}

return Sidebar;
})();

// Consolidated from src/components/MobileNavigation.jsx; keep its behavior intact.
const MobileNavigation = (()=>{



const primary=[['Dashboard','/',Fi.FiHome],['Transactions','/transactions',Fi.FiList],['Add','add',Fi.FiPlusCircle],['Budgets','/budgets',Fi.FiTarget]];
const secondary=[['Recurring','/recurring',Fi.FiRepeat],['Categories','/categories',Fi.FiGrid],['People','/people',Fi.FiUsers],['Reports','/reports',Fi.FiBarChart2],['Settings','/settings',Fi.FiSettings]];
function MobileNavigation({onAdd}){
 const [open,setOpen]=useState(false);const location=useLocation(),navigate=useNavigate(),moreRef=useRef(null),sheetRef=useRef(null);
 const isSecondary=secondary.some(([,href])=>location.pathname===href||location.pathname.startsWith(href+'/'));
 useEffect(()=>{setOpen(false)},[location.pathname]);
 useEffect(()=>{if(!open)return;const previous=document.body.style.overflow;document.body.style.overflow='hidden';const onKey=e=>{if(e.key==='Escape')setOpen(false)};document.addEventListener('keydown',onKey);sheetRef.current?.focus();return()=>{document.body.style.overflow=previous;document.removeEventListener('keydown',onKey);moreRef.current?.focus()};},[open]);
 return <div className="mobile-navigation xl:hidden">
 {open&&<div className="fixed inset-0 z-[65] bg-slate-950/50 backdrop-blur-[2px]" onMouseDown={e=>{if(e.target===e.currentTarget)setOpen(false)}}>
 <section ref={sheetRef} tabIndex={-1} role="dialog" aria-modal="true" aria-label="More navigation" className="mobile-more-sheet absolute bottom-0 inset-x-0 bg-white rounded-t-[26px] shadow-2xl overflow-y-auto outline-none">
 <div className="w-12 h-1 rounded-full bg-slate-300 mx-auto mt-3 mb-4"/><div className="flex justify-between items-center px-6 pb-3 border-b border-slate-100"><div><h2 className="text-xl font-bold text-slate-900">More</h2><p className="text-xs text-slate-500">Explore Expense Manager Pro</p></div><button type="button" onClick={()=>setOpen(false)} aria-label="Close More" className="h-11 w-11 grid place-items-center rounded-xl hover:bg-slate-100"><Fi.FiX size={23}/></button></div>
 <div className="px-4 py-4 space-y-1">{secondary.map(([label,href,Icon])=><button type="button" key={href} onClick={()=>{setOpen(false);navigate(href)}} className={'flex items-center gap-4 w-full p-3.5 rounded-xl text-left '+(location.pathname.startsWith(href)?'bg-blue-50 text-blue-700':'text-slate-700 hover:bg-slate-50')}><span className="h-11 w-11 grid place-items-center rounded-xl bg-slate-100 text-blue-600"><Icon size={21}/></span><span className="font-semibold text-sm flex-1">{label}</span><Fi.FiChevronRight className="text-slate-400"/></button>)}</div>
 </section></div>}
 <nav aria-label="Primary mobile navigation" className="mobile-nav-bar fixed z-[60] bottom-0 inset-x-0 bg-white border-t border-slate-200 shadow-[0_-6px_30px_rgba(15,23,42,.07)]"><div className="flex justify-around items-stretch h-[66px]">{primary.map(([label,href,Icon])=>href==='add'?<button key={label} type="button" onClick={onAdd} className="flex-1 min-w-0 flex flex-col gap-1 items-center justify-center text-blue-600" aria-label="Add transaction"><Icon size={27}/><span className="text-[11px] font-semibold">Add</span></button>:<NavLink key={href} end to={href} className={({isActive})=>'flex-1 min-w-0 flex flex-col gap-1 items-center justify-center '+(isActive?'text-blue-600':'text-slate-500')}><Icon size={23}/><span className="text-[11px] font-semibold">{label}</span></NavLink>)}<button ref={moreRef} type="button" aria-expanded={open} aria-haspopup="dialog" onClick={()=>setOpen(true)} className={'flex-1 min-w-0 flex flex-col gap-1 items-center justify-center '+(open||isSecondary?'text-blue-600':'text-slate-500')}><Fi.FiMoreHorizontal size={25}/><span className="text-[11px] font-semibold">More</span></button></div></nav>
 </div>
}
return MobileNavigation;
})();

// Consolidated from src/components/SplashScreen.jsx; keep its behavior intact.
const SplashScreen = (()=>{





const { FiDollarSign, FiTrendingUp } = FiIcons;

const SplashScreen = () => {
  const { state, actions } = useApp();
  const { settings } = state;

  useEffect(() => {
    const timer = setTimeout(() => {
      actions.hideSplash();
    }, 1500);

    return () => clearTimeout(timer);
  }, [actions]);

  const handleSkip = () => {
    actions.hideSplash();
  };

  const animationProps = settings.reducedMotion
    ? {}
    : {
        initial: { opacity: 0, scale: 0.9 },
        animate: { opacity: 1, scale: 1 },
        exit: { opacity: 0, scale: 0.9 },
        transition: { duration: 0.3 },
      };

  return (
    <motion.div
      className="fixed inset-0 bg-white z-50 flex items-center justify-center"
      {...animationProps}
    >
      <div className="text-center max-w-md mx-auto px-6">
        {/* Logo */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-primary-500 rounded-full mb-4">
            <SafeIcon icon={FiDollarSign} className="w-10 h-10 text-white" />
          </div>
          
          {/* App Name */}
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Expense Manager Pro 2.0
          </h1>
          
          {/* Quote */}
          <blockquote className="text-lg text-gray-700 italic mb-2">
            "What can't be tracked will not be measured or improved."
          </blockquote>
          <cite className="text-sm text-gray-500 block mb-4">— Jim Rohn</cite>
          
          {/* Sub-line */}
          <p className="text-gray-600 mb-8">
            Let's build a great financial future.
          </p>
        </div>

        {/* Loading animation */}
        {!settings.reducedMotion && (
          <div className="flex justify-center mb-6">
            <motion.div
              className="flex space-x-1"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              {[0, 1, 2].map((i) => (
                <motion.div
                  key={i}
                  className="w-2 h-2 bg-primary-500 rounded-full"
                  animate={{
                    scale: [1, 1.2, 1],
                    opacity: [0.7, 1, 0.7],
                  }}
                  transition={{
                    duration: 1,
                    repeat: Infinity,
                    delay: i * 0.2,
                  }}
                />
              ))}
            </motion.div>
          </div>
        )}

        {/* Skip button */}
        <button
          onClick={handleSkip}
          className="text-sm text-primary-600 hover:text-primary-700 underline focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 rounded"
        >
          Skip
        </button>
      </div>
    </motion.div>
  );
};



return SplashScreen;
})();

// Consolidated from src/components/QuickAddButton.jsx; keep its behavior intact.
const QuickAddButton = (()=>{






const { FiPlus } = FiIcons;

const QuickAddButton = () => {
  const { state } = useApp();
  const { settings } = state;
  const [showForm, setShowForm] = useState(false);

  useEffect(() => { const open = () => setShowForm(true); window.addEventListener('expense:quick-add', open); return () => window.removeEventListener('expense:quick-add', open); }, []);

  const animationProps = settings.reducedMotion
    ? {}
    : {
        initial: { scale: 0 },
        animate: { scale: 1 },
        exit: { scale: 0 },
        whileHover: { scale: 1.1 },
        whileTap: { scale: 0.95 },
        transition: { duration: 0.2 },
      };

  return (
    <>
      <motion.button
        onClick={() => setShowForm(true)}
        className="fixed bottom-6 right-6 w-14 h-14 hidden xl:block bg-primary-500 hover:bg-primary-600 text-white rounded-full shadow-lg focus:outline-none focus:ring-4 focus:ring-primary-300 z-30"
        {...animationProps}
      >
        <SafeIcon icon={FiPlus} className="w-6 h-6 mx-auto" />
      </motion.button>

      <AnimatePresence>
        {showForm && (
          <QuickAddForm onClose={() => setShowForm(false)} />
        )}
      </AnimatePresence>
    </>
  );
};



return QuickAddButton;
})();

// Consolidated from src/hooks/useKeyboardShortcuts.js; keep its behavior intact.
const useKeyboardShortcuts = (()=>{



const useKeyboardShortcuts = () => {
  const navigate = useNavigate();
  const { state, actions } = useApp();

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Check if user is typing in an input field
      const activeElement = document.activeElement;
      const isTyping = activeElement && (
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.contentEditable === 'true'
      );

      // Don't trigger shortcuts while typing, unless it's a global shortcut
      if (isTyping && !event.ctrlKey && !event.metaKey) {
        return;
      }

      // Global shortcuts (Ctrl/Cmd + key)
      if (event.ctrlKey || event.metaKey) {
        switch (event.key.toLowerCase()) {
          case 'k':
            event.preventDefault();
            window.dispatchEvent(new Event('expense:open-search'));
            break;
          default:
            break;
        }
        return;
      }

      // Regular shortcuts (only when not typing)
      if (!isTyping) {
        switch (event.key.toLowerCase()) {
          case 'n':
            event.preventDefault();
            // Open new transaction form
            break;
          case 'r':
            event.preventDefault();
            navigate('/recurring');
            break;
          case 'b':
            event.preventDefault();
            // Trigger backup
            break;
          case 'e':
            event.preventDefault();
            // Open export dialog
            break;
          case '/':
            event.preventDefault();
            window.dispatchEvent(new Event('expense:open-search'));
            break;
          case '?':
            event.preventDefault();
            // Show keyboard shortcuts help
            break;
          case 'g':
            // Go to shortcuts
            const nextKey = event.key;
            setTimeout(() => {
              const handleNextKey = (nextEvent) => {
                switch (nextEvent.key.toLowerCase()) {
                  case 'd':
                    navigate('/');
                    break;
                  case 't':
                    navigate('/transactions');
                    break;
                  case 'r':
                    navigate('/recurring');
                    break;
                  case 'b':
                    navigate('/budgets');
                    break;
                  case 'p':
                    navigate('/people');
                    break;
                  case 's':
                    navigate('/settings');
                    break;
                }
                document.removeEventListener('keydown', handleNextKey, { once: true });
              };
              document.addEventListener('keydown', handleNextKey, { once: true });
            }, 100);
            break;
          default:
            break;
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [navigate, actions]);
};

return useKeyboardShortcuts;
})();


// Kept as a private BackupStatus module to preserve the original component behavior.
const BackupStatus = (()=>{







const { FiHardDrive, FiFolderOpen } = FiIcons;

const BackupStatus = () => {
  const { state } = useApp();
  const { settings } = state;
  const [backupStatus, setBackupStatus] = useState('up-to-date');
  const [showTooltip, setShowTooltip] = useState(false);
  const [lastBackup, setLastBackup] = useState(null);
  const [nextBackup, setNextBackup] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      updateBackupStatus();
    }, 60000); // Update every minute

    updateBackupStatus();
    return () => clearInterval(interval);
  }, []);

  const updateBackupStatus = async () => {
    try {
      const lastBackupTime = await settingsService.getSetting('lastBackup');
      setLastBackup(lastBackupTime);

      if (!lastBackupTime) {
        setBackupStatus('overdue');
        return;
      }

      const now = new Date();
      const lastBackupDate = new Date(lastBackupTime);
      const timeDiff = now - lastBackupDate;
      const minutesDiff = Math.floor(timeDiff / (1000 * 60));

      if (minutesDiff > 15) {
        setBackupStatus('overdue');
      } else if (minutesDiff > 10) {
        setBackupStatus('warning');
      } else {
        setBackupStatus('up-to-date');
      }

      // Calculate next backup time
      const nextBackupTime = new Date(lastBackupDate.getTime() + (15 * 60 * 1000));
      setNextBackup(nextBackupTime);
    } catch (error) {
      console.error('Failed to update backup status:', error);
      setBackupStatus('error');
    }
  };

  const performBackup = async () => {
    try {
      const data = await dbService.exportData();
      const blob = new Blob([JSON.stringify(data, null, 2)], {
        type: 'application/json',
      });

      const filename = `expense-manager-backup-${new Date().toISOString().split('T')[0]}.json`;
      
      // Check if File System Access API is available (Chromium browsers)
      if ('showSaveFilePicker' in window) {
        try {
          const fileHandle = await window.showSaveFilePicker({
            suggestedName: filename,
            types: [{
              description: 'JSON files',
              accept: { 'application/json': ['.json'] },
            }],
          });
          
          const writable = await fileHandle.createWritable();
          await writable.write(blob);
          await writable.close();
          
          await settingsService.setSetting('lastBackup', new Date().toISOString());
          setBackupStatus('up-to-date');
          updateBackupStatus();
        } catch (err) {
          if (err.name !== 'AbortError') {
            throw err;
          }
        }
      } else {
        // Fallback for other browsers
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        
        await settingsService.setSetting('lastBackup', new Date().toISOString());
        setBackupStatus('up-to-date');
        updateBackupStatus();
      }
    } catch (error) {
      console.error('Backup failed:', error);
      setBackupStatus('error');
    }
  };

  const getStatusColor = () => {
    switch (backupStatus) {
      case 'up-to-date':
        return 'text-success-500';
      case 'warning':
        return 'text-warning-500';
      case 'overdue':
        return 'text-danger-500';
      case 'error':
        return 'text-danger-600';
      default:
        return 'text-gray-500';
    }
  };

  const getTooltipContent = () => {
    const formatTime = (date) => {
      return date ? new Date(date).toLocaleString('en-AU') : 'Never';
    };

    const getCountdown = () => {
      if (!nextBackup) return 'Unknown';
      const now = new Date();
      const diff = nextBackup - now;
      if (diff <= 0) return 'Overdue';
      
      const minutes = Math.floor(diff / (1000 * 60));
      const hours = Math.floor(minutes / 60);
      
      if (hours > 0) {
        return `${hours}h ${minutes % 60}m`;
      }
      return `${minutes}m`;
    };

    return (
      <div className="text-xs space-y-1">
        <div>Last backup: {formatTime(lastBackup)}</div>
        <div>Next backup: {getCountdown()}</div>
        <div>Status: {backupStatus.replace('-', ' ')}</div>
        {settings.backupFolder && (
          <div>Folder: {settings.backupFolder}</div>
        )}
        {'showDirectoryPicker' in window && settings.backupFolder && (
          <button
            onClick={async () => {
              try {
                const dirHandle = await window.showDirectoryPicker();
                // Open folder logic here
              } catch (err) {
                console.error('Failed to open folder:', err);
              }
            }}
            className="flex items-center mt-2 px-2 py-1 bg-primary-500 text-white rounded text-xs hover:bg-primary-600"
          >
            <SafeIcon icon={FiFolderOpen} className="w-3 h-3 mr-1" />
            Open Folder
          </button>
        )}
      </div>
    );
  };

  const animationProps = settings.reducedMotion
    ? {}
    : {
        initial: { scale: 0 },
        animate: { scale: 1 },
        whileHover: { scale: 1.1 },
        transition: { duration: 0.2 },
      };

  return (
    <div className="fixed bottom-6 left-6 z-30">
      <div className="relative">
        <motion.button
          onClick={performBackup}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          className={`w-12 h-12 rounded-full shadow-lg focus:outline-none focus:ring-4 focus:ring-primary-300 ${getStatusColor()} bg-white border-2 border-current`}
          {...animationProps}
        >
          <SafeIcon icon={FiHardDrive} className="w-5 h-5 mx-auto" />
        </motion.button>

        {/* Tooltip */}
        {showTooltip && (
          <motion.div
            className="absolute bottom-full left-0 mb-2 p-3 bg-gray-900 text-white rounded-lg shadow-lg whitespace-nowrap"
            initial={settings.reducedMotion ? {} : { opacity: 0, y: 10 }}
            animate={settings.reducedMotion ? {} : { opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
          >
            {getTooltipContent()}
            <div className="absolute top-full left-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900" />
          </motion.div>
        )}
      </div>
    </div>
  );
};



return BackupStatus;
})();

const AppShell = ({ children }) => {
  const { state, actions } = useApp();
  const location = useLocation();
  const { isLoading, ui, settings } = state;

  useKeyboardShortcuts();

  const shouldShowSplash = isLoading || ui.showSplash;
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 1280;

  useEffect(() => {
    // Close sidebar on route change on mobile
    if (isMobile && ui.sidebarOpen) {
      actions.toggleSidebar();
    }
  }, [location.pathname]);

  // Only dedicated document viewer surfaces may enable browser pinch zoom.
  // A viewer sets data-document-viewer on its root while open.
  useEffect(() => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) return;
    const locked = viewport.getAttribute('content');
    const unlocked = 'width=device-width, initial-scale=1.0, maximum-scale=5.0, minimum-scale=1.0, user-scalable=yes, viewport-fit=cover';
    const sync = () => viewport.setAttribute('content',
      document.querySelector('[data-document-viewer]') ? unlocked : locked);
    const observer = new MutationObserver(sync);
    observer.observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['data-document-viewer']});
    sync();
    return () => {observer.disconnect(); viewport.setAttribute('content', locked)};
  }, []);

  // iOS Safari may ignore user-scalable=no. Restrict application pinch gestures,
  // while keeping explicitly marked document previews zoomable.
  useEffect(() => {
    const isDocumentGesture = target => target instanceof Element &&
      Boolean(target.closest('[data-document-viewer]'));
    const blockGesture = event => {
      if (isDocumentGesture(event.target)) return;
      if (event.touches && event.touches.length > 1 && event.cancelable) event.preventDefault();
      if (event.type === 'gesturestart' || event.type === 'gesturechange') {
        if (event.cancelable) event.preventDefault();
      }
      if (event.type === 'wheel' && event.ctrlKey && event.cancelable) event.preventDefault();
    };
    document.addEventListener('touchmove', blockGesture, { passive: false });
    document.addEventListener('gesturestart', blockGesture, { passive: false });
    document.addEventListener('gesturechange', blockGesture, { passive: false });
    document.addEventListener('wheel', blockGesture, { passive: false });
    return () => {
      document.removeEventListener('touchmove', blockGesture);
      document.removeEventListener('gesturestart', blockGesture);
      document.removeEventListener('gesturechange', blockGesture);
      document.removeEventListener('wheel', blockGesture);
    };
  }, []);

  const animationProps = settings.reducedMotion
    ? {}
    : {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 0.3 },
      };

  return (
    <div className="min-h-screen bg-[#f6f9fc]">
      <AnimatePresence>
        {shouldShowSplash && <SplashScreen />}
      </AnimatePresence>

      {!shouldShowSplash && (
        <motion.div
          className="flex h-[100dvh] overflow-hidden"
          {...animationProps}
        >
          {/* Sidebar */}
          <Sidebar />

          {/* Main content */}
          <div className="flex-1 min-w-0 flex flex-col overflow-hidden">
            <Header />
            
            <main className="flex-1 min-w-0 overflow-x-hidden overflow-y-auto native-mobile-scroll">
              <div className="mx-auto min-w-0 w-full px-3 sm:px-5 lg:px-7 py-4 sm:py-6 max-w-[1740px] mobile-content">
                {children}
              </div>
            </main>
          </div>

          {/* Mobile sidebar overlay */}
          {ui.sidebarOpen && isMobile && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-40 xl:hidden"
              onClick={actions.toggleSidebar}
            />
          )}

          <MobileNavigation onAdd={() => window.dispatchEvent(new Event('expense:quick-add'))} />

          {/* Quick Add Button */}
          <QuickAddButton />

          {/* Backup Status */}
          <BackupStatus />
        </motion.div>
      )}
    </div>
  );
};

export default AppShell;